/* assets/product-recommendations.js — kompakt */

/* === kleine Helfer === */
var EPS_PX = 2, EPS_RATIO = 0.02; // Toleranz: max(2px, 2% der Viewportbreite)
function eps(page){ return Math.max(EPS_PX, Math.round(page * EPS_RATIO)); }

function getState(vp){
  var page = vp.clientWidth || (vp.getBoundingClientRect && vp.getBoundingClientRect().width) || 0;
  var max  = Math.max(0, vp.scrollWidth - vp.clientWidth);
  var left = vp.scrollLeft || 0;
  var e    = eps(page);
  return {
    page: page, max: max, left: left, e: e,
    scrollable: max > e,
    atStart: left <= e,
    atEnd:   left >= (max - e)
  };
}

function updateNav(root){
  if(!root) return;
  var vp  = root.querySelector('[data-slider-viewport]');
  var nav = root.querySelector('.rec-slider__nav');
  if(!vp || !nav) return;

  var s = getState(vp);
  nav.style.display = s.scrollable ? 'flex' : 'none';

  var prev = root.querySelector('.rec-slider__btn--prev');
  var next = root.querySelector('.rec-slider__btn--next');
  if(prev) prev.disabled = (!s.scrollable || s.atStart);
  if(next) next.disabled = (!s.scrollable || s.atEnd);
}

function bindOne(root){
  if(!root || root.__recBound) return;
  var vp  = root.querySelector('[data-slider-viewport]');
  var nav = root.querySelector('.rec-slider__nav');
  if(!vp || !nav) return;

  root.__recBound = true;
  nav.style.display = 'none';

  vp.addEventListener('scroll', function(){ updateNav(root); }, {passive:true});

  // schlanke Observers (optional, aber hilfreich)
  try{
    var ro = new ResizeObserver(function(){ updateNav(root); });
    ro.observe(vp);
    var track = root.querySelector('.rec-slider__track');
    if(track) ro.observe(track);

    var mo = new MutationObserver(function(){ updateNav(root); });
    if(track) mo.observe(track, {childList:true, subtree:true});
  }catch(_){}

  // initial & leicht verzögert (für Bilder/Fonts)
  updateNav(root);
  (window.requestAnimationFrame || setTimeout)(function(){ updateNav(root); }, 16);
  setTimeout(function(){ updateNav(root); }, 150);
}

function bindAll(){
  var nodes = document.querySelectorAll('[data-rec-slider], .rec-slider');
  for(var i=0;i<nodes.length;i++) bindOne(nodes[i]);
}

/* === öffentliche API für Buttons (ID-basiert aus Snippet) === */
window.__recSliderNavById = function(vpId, dir){
  var vp = document.getElementById(vpId);
  if(!vp) return false;
  var root = vp.closest('[data-rec-slider]') || vp.closest('.rec-slider');
  if(root && !root.__recBound) bindOne(root);

  var s = getState(vp);
  if(!s.page) return false;

  var target = Math.min(s.max, Math.max(0, s.left + (dir>0?1:-1)*s.page));
  if(vp.scrollTo) vp.scrollTo({left: target, behavior: 'smooth'}); else vp.scrollLeft = target;
  if(root) updateNav(root);
  return false;
};

/* === Init: sofort, bei DOM ready, bei Shopify-Events, bei DOM-Mutationen === */
bindAll();
document.addEventListener('DOMContentLoaded', bindAll);
window.addEventListener('load', bindAll);
document.addEventListener('shopify:section:load', bindAll);
document.addEventListener('shopify:section:reorder', bindAll);

try{
  var moRoot = new MutationObserver(function(){ bindAll(); });
  moRoot.observe(document.documentElement, {childList:true, subtree:true});
}catch(_){}
